/**
 * "POS mode": this browser tab was signed in by a Simphony till through `/pos`.
 *
 * The till shows crqlar inside a page control next to Simphony's own check panel, so the dashboard
 * drops chrome a till does not need (the module title row in `PageShell`) to give the floor plan the
 * height.
 *
 * Kept in `sessionStorage` on purpose: it is per tab, so an ordinary crqlar tab in the same browser is
 * never affected, and it survives in-tab reloads (e.g. "Try again") for the life of the till's page.
 * Every access is guarded — storage can be unavailable or throw in locked-down embedded browsers.
 */
const POS_MODE_KEY = "crqlar.posMode";

export function enterPosMode(): void {
    try {
        sessionStorage.setItem(POS_MODE_KEY, "1");
    } catch {
        // No storage: the till still works, it just keeps the title.
    }
}

export function isPosMode(): boolean {
    try {
        return sessionStorage.getItem(POS_MODE_KEY) === "1";
    } catch {
        return false;
    }
}
